module.exports = __webpack_public_path__ + "img/order_form_image@3x.4c97fa7b.png";